import {NavigationProp, ParamListBase} from '@react-navigation/native';
import {Box, HStack, Pressable, Text} from 'native-base';
import React from 'react';
import Icon from 'react-native-vector-icons/FontAwesome5Pro';

import {Routes} from 'models/Navigation';
import {useTheme} from 'styled-components/native';

export interface FilterBarProps {
  filteredOffersCount: number;
  hasFiltersApplied: boolean;
  navigation?: NavigationProp<ParamListBase>;
}

const FilterBar: React.FC<FilterBarProps> = props => {
  const {filteredOffersCount, hasFiltersApplied, navigation} = props;
  const theme = useTheme();
  const {white, paleSky, tuna} = theme.colors;

  const navigateToFilters = () => {
    if (typeof navigation !== 'undefined') {
      navigation.navigate(Routes.Offers.Filters);
    }
  };

  const filteredOffersCountText = (text: string) => {
    const isResult = text.toUpperCase() === 'RESULT';

    if (hasFiltersApplied) {
      if (filteredOffersCount === 1) {
        return isResult ? '1 RESULT' : 'FILTER  (1 OFFER)';
      }
      return isResult
        ? `${filteredOffersCount} RESULTS`
        : `FILTER  (${filteredOffersCount} OFFERS)`;
    }
    return 'FILTER';
  };

  return (
    <Box width="100%">
      <Pressable
        accessibilityLabel="Open filter menu"
        onPress={navigateToFilters}
        height="40px"
        borderRadius="md"
        shadow={1}
        bg={white}
        px={4}
        alignContent="center"
        justifyContent="center">
        <HStack alignItems="flex-start" alignContent="center">
          <Icon
            name="sliders-h"
            size={theme.fontSizes[4]}
            color={paleSky}
            style={{
              marginRight: theme.space[4],
              width: 14,
            }}
            solid
          />
          <Text fontSize={2} fontFamily="heading" fontWeight={700} color={tuna}>
            {filteredOffersCountText('offer')}
          </Text>
        </HStack>
      </Pressable>
    </Box>
  );
};

export default FilterBar;
